import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { environment } from '../environments/environment';
import { KsefOfflineBootstrapService } from './core/ksef/ksef-offline-bootstrap.service';

@Component({
  selector: 'pos-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  private readonly transloco = inject(TranslocoService);
  private readonly ksefOffline = inject(KsefOfflineBootstrapService);

  constructor() {
    this.transloco.setActiveLang(environment.defaultLanguage);
    // Certyfikat trybu awaryjnego KSeF musi być na kasie, zanim zerwie się łączność —
    // pobieramy go zaraz po wybraniu firmy, a nie dopiero przy pierwszej sprzedaży offline.
    this.ksefOffline.start();
  }
}
